import clsx from "clsx";
import { useRef, Children, cloneElement, useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import useViewport, { Viewport } from "../../hooks/useViewport";

import CarouselButtons from "../carousel-buttons";

import styles from "./carousel-multiple.module.scss";

const CarouselMultiple = ({ title, description, children }) => {
  const arrayChildren = Children.toArray(children);
  const [currentSlide, setCurrentSlide] = useState(0);
  const scrollRef = useRef();

  const device = useViewport();

  const renderSlide = (slide, index) => {
    const clone = cloneElement(slide, {
      onClick: () => setCurrentSlide(index)
    });

    return clone;
  };

  useEffect(() => {
    // If we're on desktop, handle custom slide into view.
    if (scrollRef.current && device !== Viewport.PHONE) {
      const count = arrayChildren.length;
      const slideWidth = scrollRef.current.childNodes[0].clientWidth;

      let scrollTo = slideWidth * (currentSlide - 1);

      if (currentSlide < 2) {
        scrollTo = 0;
      }

      if (currentSlide > count - 2) {
        scrollTo = slideWidth * count;
      }

      scrollRef.current.scrollTo({
        left: scrollTo,
        behavior: "smooth"
      });
    }
  }, [scrollRef, currentSlide, arrayChildren, device]);

  if (device === Viewport.PHONE) {
    return (
      <div className={styles.MobileCarousel}>
        <div className={clsx("container", styles.CarouselMultiple)}>
          <h2>{title}</h2>

          <p>{description}</p>
        </div>

        <Carousel
          showArrows={false}
          showIndicators={false}
          showThumbs={false}
          showStatus={false}
          autoPlay={false}
          selectedItem={currentSlide}
          onChange={setCurrentSlide}
          swipeScrollTolerance={20}
          preventMovementUntilSwipeScrollTolerance
        >
          {arrayChildren.map((slide) => slide)}
        </Carousel>

        <CarouselButtons
          slides={arrayChildren.map((slide, index) => ({
            active: index === currentSlide
          }))}
          onChange={setCurrentSlide}
        />
      </div>
    );
  }

  return (
    <>
      <div className={clsx("container", styles.CarouselMultiple)}>
        <h2>{title}</h2>

        <p>{description}</p>
      </div>

      <div className={styles.Carousel} ref={scrollRef}>
        {arrayChildren.map(renderSlide)}
      </div>
      <CarouselButtons
        slides={arrayChildren.map((slide, index) => ({
          active:
            index === currentSlide || // current
            index === currentSlide - 1 || // prev
            index === currentSlide + 1 || // next
            (currentSlide === 0 && index === currentSlide + 2) || // first three
            (currentSlide === arrayChildren.length - 1 &&
              index === currentSlide - 2) //last three
        }))}
        onChange={setCurrentSlide}
      />
    </>
  );
};

export default CarouselMultiple;
